// Shared UI constants for the multilingual support ticket system.
// `key` maps to a CMS translation; render with metaLabel(meta, t) where t = useContent().t.
export const LANG_META = {
  fr: { key: "support.lang.fr", label: "Français", flag: "🇫🇷", color: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  en: { key: "support.lang.en", label: "English", flag: "🇬🇧", color: "bg-indigo-500/15 text-indigo-400 border-indigo-500/30" },
  sw: { key: "support.lang.sw", label: "Swahili", flag: "🇹🇿", color: "bg-teal-500/15 text-teal-400 border-teal-500/30" },
  unverified: { key: "support.lang.unverified", label: "À vérifier", flag: "❓", color: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
};

export const STATUS_META = {
  waiting: { key: "support.status.waiting", label: "En attente", color: "bg-amber-500/15 text-amber-400" },
  in_progress: { key: "support.status.in_progress", label: "En cours", color: "bg-blue-500/15 text-blue-400" },
  waiting_client: { key: "support.status.waiting_client", label: "En attente du client", color: "bg-purple-500/15 text-purple-400" },
  waiting_internal: { key: "support.status.waiting_internal", label: "En attente interne", color: "bg-cyan-500/15 text-cyan-400" },
  resolved: { key: "support.status.resolved", label: "Résolu", color: "bg-emerald-500/15 text-emerald-400" },
  closed: { key: "support.status.closed", label: "Fermé", color: "bg-slate-500/20 text-slate-400" },
};

export const PRIORITY_META = {
  low: { key: "support.priority.low", label: "Basse", color: "text-slate-400" },
  normal: { key: "support.priority.normal", label: "Normale", color: "text-slate-300" },
  high: { key: "support.priority.high", label: "Haute", color: "text-orange-400" },
  urgent: { key: "support.priority.urgent", label: "Urgente", color: "text-red-400" },
  critical: { key: "support.priority.critical", label: "Critique", color: "text-red-500 font-bold" },
};

// SLA status chips (staff-only — never shown to the customer).
export const SLA_META = {
  on_track: { key: "support.sla.on_track", label: "Dans les délais", color: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  due_soon: { key: "support.sla.due_soon", label: "Bientôt dépassé", color: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  breached: { key: "support.sla.breached", label: "SLA dépassé", color: "bg-red-500/15 text-red-400 border-red-500/30" },
  met: { key: "support.sla.met", label: "SLA respecté", color: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  unknown: { key: "support.sla.unknown", label: "—", color: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
};

// Human duration from minutes (e.g. 90 -> "1 h 30", 30 -> "30 min", -15 -> "-15 min").
export const fmtDuration = (mins) => {
  if (mins === null || mins === undefined) return "—";
  const neg = mins < 0;
  let m = Math.abs(Math.round(mins));
  if (m < 60) return `${neg ? "-" : ""}${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (h < 24) return `${neg ? "-" : ""}${h} h${r ? " " + r : ""}`;
  const d = Math.floor(h / 24);
  return `${neg ? "-" : ""}${d} j${h % 24 ? " " + (h % 24) + " h" : ""}`;
};

// Resolve a meta's label through the CMS when `t` is provided; falls back to the FR default.
export const metaLabel = (meta, t) => (meta ? (t ? t(meta.key, meta.label) : meta.label) : "");
export const langLabel = (l, t) => metaLabel(LANG_META[l] || LANG_META.unverified, t);
export const statusLabel = (s, t) => metaLabel(STATUS_META[s], t) || s;
